<div class="modal-body">
  <div class="modal-text-wrapper">
    <p>{{information}}</p>
  </div>
  
  <button type="button" class="modal-btn-primary" (click)="activeModal.close('Close click')">{{positiveButton}}</button>
</div>